<template>
  <footer
    v-if="message"
    class="channel-typing__container"
    :data-is-private="shouldShowPrivate"
    v-html="message"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    isPrivate: Boolean
  },
  computed: {
    ...mapState('channel/staff', ['loggedStaff']),
    ...mapGetters('pillars/channel', ['currentChannel', 'channelMember']),
    message() {
      const typing = this.isPrivate ? 'privateTyping' : 'typing'
      const channelStaffs = this.currentChannel.staffArray
      const participants = this.currentChannel[typing]
        .filter(id => id !== this.loggedStaff.id)
        .map(id => {
          const isMember = this.channelMember?.channelPersonId === id
          if (isMember)
            return `<strong>${this.channelMember.displayName}</strong>`
          const staff = channelStaffs.find(staff => staff.id === id)
          if (staff) return `<strong>${staff.participantName}</strong>`
        })
        .filter(Boolean)
      if (!participants.length) return
      const list = new Intl.ListFormat('pt-BR')
      return `${list.format(participants)} ${
        participants.length === 1 ? 'está' : 'estão'
      } digitando...`
    },
    shouldShowPrivate() {
      return this.isPrivate || null
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.channel-typing__container {
  @extend %caption;
  background-color: var(--sys-color-surface-background-light);
  color: var(--sys-color-content-tertiary);
  position: fixed;
  bottom: 2px;
  margin-left: var(--gl-spacing-02);
  z-index: 1;

  &[data-is-private] {
    background-color: var(--gl-color-shades-gray-90);
    color: var(--gl-color-shades-gray-30);
  }
}
</style>
